import React from "react";
import { signIn, signOut } from "next-auth/react";
import Logo from "../Logo";
import { CartSheet } from "../CartSheet";
import { NavLink } from "./NavLink";
import { useNavContext } from "./NavContext";
import { useLocalOrders, useUpcomingRaves } from "./NavHooks";
import Link from "next/link";

const DesktopNavigation: React.FC = () => {
  const { session } = useNavContext();
  const { hasUpcomingRaves, upcomingRaveDetails } = useUpcomingRaves();
  const { hasOrders } = useLocalOrders();

  return (
    <>
      <div className="hidden lg:flex space-x-12">
        <NavLink href="/products" ariaLabel="Go to Products">
          Products
        </NavLink>
        <div className="flex items-center space-x-1">
          <NavLink href="/raves" ariaLabel="View Raves">
            Raves
          </NavLink>
          {hasUpcomingRaves && (
            <span
              className="h-1 w-1 rounded-full bg-[#FF0000]"
              aria-hidden="true"
            />
          )}
        </div>
        <NavLink href="/gallery" ariaLabel="Open Gallery">
          Gallery
        </NavLink>
        <NavLink
          href="https://drive.google.com/drive/folders/1QMP6sbYcWpHwk0JUPZcaw3TsF81NQg98"
          ariaLabel="Go to wallpapers"
        >
          Wallpapers
        </NavLink>
      </div>

      <div className="absolute left-1/2 transform -translate-x-1/2 scale-75 lg:scale-100">
        <Logo />
      </div>

      <div
        className={`${
          hasUpcomingRaves ? "mt-6" : ""
        } hidden lg:flex space-x-12 items-center`}
      >
        {session ? (
          <>
            <NavLink
              href={`/users/${session.user.id}`}
              ariaLabel="View Profile"
            >
              {session.user?.name ? `${session.user.name}` : "Profile"}
            </NavLink>
            <button
              className="text-xs uppercase hover:underline"
              onClick={() => signOut()}
              aria-label="Log out"
            >
              Log out
            </button>
          </>
        ) : (
          <button
            className="text-xs uppercase hover:underline"
            onClick={() => signIn()}
            aria-label="Log in"
          >
            Login
          </button>
        )}

        <div className="flex items-center space-x-1">
          <NavLink href="/orders" ariaLabel="View Orders">
            Orders
          </NavLink>
          {hasOrders && (
            <span
              className="h-1 w-1 rounded-full bg-[#FF0000]"
              aria-hidden="true"
            />
          )}
        </div>

        <CartSheet />
      </div>
    </>
  );
};

DesktopNavigation.displayName = "DesktopNavigation";
export default DesktopNavigation;
